import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { resilienceApi, type ResilienceDashboard } from '../../api/resilience';

export function BusinessContinuityDashboardPage() {
  const [dash, setDash] = useState<ResilienceDashboard | null>(null);
  useEffect(() => { void resilienceApi.dashboard().then(setDash); }, []);
  return (
    <div className="mx-auto max-w-6xl p-6">
      <h1 className="text-2xl font-semibold dark:text-slate-100">Business Continuity Dashboard</h1>
      <Link to="/resilience" className="mt-2 inline-block text-sm text-emerald-700 hover:underline dark:text-emerald-400">← Resilience Hub</Link>
      <div className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        <div className="rounded-xl border p-4 dark:border-slate-700"><p className="text-sm text-slate-500">Disaster Readiness</p><p className="text-2xl font-semibold">{dash?.last_drill_passed ? 'Ready' : 'Review Required'}</p></div>
        <div className="rounded-xl border p-4 dark:border-slate-700"><p className="text-sm text-slate-500">Active Restores</p><p className="text-2xl font-semibold">{dash?.active_restores ?? 0}</p></div>
        <div className="rounded-xl border p-4 dark:border-slate-700"><p className="text-sm text-slate-500">Platform Modules</p><p className="text-2xl font-semibold">{dash?.platform_health?.filter((m) => m.status === 'healthy').length ?? 0} healthy</p></div>
      </div>
    </div>
  );
}
